import React from 'react';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useFilterContainerClassName, useFilterInputContainerClassName } from '../../../../../utils/languageUtils';
import { getSmartLabelClassName } from '../../../../../utils/labelWidthUtils';

export type FilterOptions = {
  id: string;
  code: string;
  name: string;
  description: string;
};

export const DEFAULT_FILTERS: FilterOptions = {
  id: '',
  code: '',
  name: '',
  description: '',
};

interface Props {
  filters: FilterOptions;
  setFilters: (filters: FilterOptions) => void;
}

const ResourceFilterArea: React.FC<Props> = ({ filters, setFilters }) => {
  const { t } = useTranslation();
  const containerClassName = useFilterContainerClassName();
  const inputContainerClassName = useFilterInputContainerClassName();

  const labelId = String(t('central.platformPermission.resource.filters.id'));
  const labelCode = String(t('central.platformPermission.resource.filters.code'));
  const labelName = String(t('central.platformPermission.resource.filters.name'));
  const labelDescription = String(t('central.platformPermission.resource.filters.description'));
  const colLabels = [labelId, labelCode, labelName, labelDescription];

  return (
    <div className="mb-2 pl-0 py-2">
      <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
        <div className="min-w-0">
          <div className={containerClassName}>
            <span className={getSmartLabelClassName(colLabels)}>{labelId}</span>
            <div className={inputContainerClassName}>
              <Input
                value={filters.id}
                onChange={(e) => setFilters({ ...filters, id: e.target.value })}
                allowClear
                size="middle"
                className="w-full"
                placeholder={t('components.input.typeIn') as string}
              />
            </div>
          </div>
        </div>
        <div className="min-w-0">
          <div className={containerClassName}>
            <span className={getSmartLabelClassName(colLabels)}>{labelCode}</span>
            <div className={inputContainerClassName}>
              <Input
                value={filters.code}
                onChange={(e) => setFilters({ ...filters, code: e.target.value })}
                allowClear
                size="middle"
                className="w-full"
                placeholder={t('components.input.typeIn') as string}
              />
            </div>
          </div>
        </div>
        <div className="min-w-0">
          <div className={containerClassName}>
            <span className={getSmartLabelClassName(colLabels)}>{labelName}</span>
            <div className={inputContainerClassName}>
              <Input
                value={filters.name}
                onChange={(e) => setFilters({ ...filters, name: e.target.value })}
                allowClear
                size="middle"
                className="w-full"
                placeholder={t('components.input.typeIn') as string}
              />
            </div>
          </div>
        </div>
        <div className="min-w-0">
          <div className={containerClassName}>
            <span className={getSmartLabelClassName(colLabels)}>{labelDescription}</span>
            <div className={inputContainerClassName}>
              <Input
                value={filters.description}
                onChange={(e) => setFilters({ ...filters, description: e.target.value })}
                allowClear
                size="middle"
                className="w-full"
                placeholder={t('components.input.typeIn') as string}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourceFilterArea;

